"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _defineType = require("../_util/defineType");
var _collapse = _interopRequireDefault(require("./collapse"));
var _text = _interopRequireDefault(require("./text"));
var _title = _interopRequireDefault(require("./title"));
var _jsxRuntime = require("react/jsx-runtime");
const titleSizeMap = {
  h4: '20-24',
  h5: '18-20',
  h6: '16-20',
  h7: '14-18'
};
const Typography = props => {
  const {
    level = 'h5',
    title,
    checkbox,
    extra,
    info,
    help,
    subtitle,
    tips,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-typography");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...restProps,
    className: (0, _classnames.default)(baseClassName, level, className),
    style: style,
    children: [!(0, _defineType.isNone)(title) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_title.default, {
      size: titleSizeMap[level],
      checkbox: checkbox,
      extra: extra,
      info: info,
      help: help,
      children: title
    }), !(0, _defineType.isNone)(subtitle) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(baseClassName, "-subtitle"),
      children: subtitle
    }), !(0, _defineType.isNone)(children) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(baseClassName, "-content"),
      children: children
    }), !(0, _defineType.isNone)(tips) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(baseClassName, "-tips"),
      children: tips
    })]
  });
};
Typography.Title = _title.default;
Typography.Text = _text.default;
Typography.Collapse = _collapse.default;
var _default = exports.default = Typography;